import { render } from "./WithdrawPopup.vue?vue&type=template&id=6a37bf23&ts=true"
import script from "./WithdrawPopup.vue?vue&type=script&lang=ts"
export * from "./WithdrawPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__